import React, { useEffect, useRef, useState, Suspense } from 'react';
import 'map-component/index.css';
import { MapComponent } from 'map-component/esm-lib/src/index';

function Map() {
  const mapContainer = useRef();
  const mapComponent = useRef();

  // add a state for basemap
  const [basemap, setBasemap] = useState('gray-vector');
  const [theme, setTheme] = useState('light');

  const toggleTheme = () => {
    if (theme === 'light') {
      setTheme('dark');
      setBasemap('dark-gray-vector');
    } else {
      setTheme('light');
      setBasemap('gray-vector');
    }
  };

  useEffect(() => {
    if (mapComponent.current) {
      // Destroy the existing map component before creating a new one
      mapComponent.current = null;
    }

    mapComponent.current = new MapComponent({
      nodeLayer: {
        layerUrl:
          'https://services-eu1.arcgis.com/kkoySFboPZ70Z0Od/arcgis/rest/services/Grid_Map_view/FeatureServer/0',
        minScale: 2000000,
        maxScale: null,
        title: 'Node',
      },

      edgeLayer: {
        layerUrl:
          'https://services-eu1.arcgis.com/kkoySFboPZ70Z0Od/arcgis/rest/services/Grid_Map_view/FeatureServer/1',
        maxScale: null,
        title: 'Edge',
      },
      token: '',
      container: mapContainer.current,
      minZoom: 3,
      basemap: basemap,
      publicView: true,
      showPrint: true,
      bbox: {
        xmin: -4909909.304138051,
        ymin: 8457120.8963899,
        xmax: 9989094.28136471,
        ymax: 5176688.02630598,
        wkid: 102100,
      },
      updateCallback: () => {
        console.log('update');
      },
      addCallback: () => {
        console.log('add');
      },
      selectCallback: async (feature) => {
        console.log('select', feature.attributes);
      },
      errorCallback: (err) => console.log(err),
    });

    mapComponent.current.launch();

    // Cleanup when the component unmounts
    return () => {
      mapComponent.current = null;
    };
  }, [basemap]);

  return (
    <div ref={mapContainer} className="map-container">
      <button
        style={{
          position: 'absolute',
          right: 15,
          top: 15,
          padding: 10,
          cursor: 'pointer',
          backgroundColor: '#0f62fe',
          color: '#fff',
          border: 'none',
        }}
        onClick={toggleTheme}
      >
        {theme === 'light' ? 'Dark Mode' : 'Light Mode'}
      </button>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Suspense fallback={<div>Loading...</div>}>
        <Map />
      </Suspense>
    </div>
  );
}

export default App;
